<template>
  <div class="flexLeftCol sideNav">
    <div style="height: 40px; margin-bottom: 20px">
      <img
        src="@/assets/images/moonarch-logo-small.svg"
        class="mlogo smallLogo"
      />
      <img src="@/assets/images/moonarch-logo-big.svg" class="mlogo bigLogo" />
    </div>
    <NavButton
      :icon="CirclePlus"
      text="New Workflow"
      @click="routerPush(this.$router, '/newboard')"
      :isSelected="this.$route.path == '/newboard'"
      :isSideBar="true"
      width="198px"
    />
    <NavButton
      :icon="Zap"
      text="My Workflows"
      @click="routerPush(this.$router, '/boardlist')"
      :isSelected="this.$route.path == '/boardlist'"
      :isSideBar="true"
      width="198px"
    />
    <NavButton
      :icon="GitCompareArrows"
      text="My Connections"
      @click="routerPush(this.$router, '/connections')"
      :isSelected="this.$route.path == '/connections'"
      :isSideBar="true"
      width="198px"
    />
  </div>
</template>

<script>
// import firebase from "firebase";
// import db from "@/main.js";
// import { ref } from "vue";
import {
  CirclePlus,
  Zap,
  Logs,
  LayoutDashboard,
  GitCompareArrows,
} from "lucide-vue-next";
import NavButton from "../buttons/NavButton.vue";
import routerPush from "../../utilities";

export default {
  name: "SideNav",
  components: {
    NavButton,
    //lucide
    // MessagesSquare,
  },
  methods: {},
  setup() {
    return {
      routerPush,
    };
  },
  data() {
    return {
      // navItems: ['New workflow', 'WorkflowList', 'Logs', 'Dashboard'],
      CirclePlus,
      Zap,
      Logs,
      LayoutDashboard,
      GitCompareArrows,
    };
  },
};
</script>

<style scoped>
.sideNav {
  /* border-right: thin solid #dadada; */
  height: 100%;
  width: 50px;
  z-index: 100;
  background: #f9f4ff;
  border-right: thin solid lightgray;
  transition: ease-in-out 0.1s;
  overflow: hidden;
  position: fixed;
  height: 100%;
}
.sideNav:hover {
  width: 200px;
}
.mlogo {
  padding: 15px;
  cursor: pointer;
}
.smallLogo {
  height: 20px;
  display: block;
}
.bigLogo {
  height: 23px;
  display: none;
  transform: translateY(-3px);
}
.sideNav:hover .smallLogo {
  display: none;
}
.sideNav:hover .bigLogo {
  display: block;
}
.navBtn {
  padding: 1px 7px;
  margin: 2px 4px;
  border-radius: 7px;
  cursor: pointer;
}
.navBtn:hover {
  background: #dadada;
}
.navBtnImg {
  min-height: 38px;
  min-width: 38px;
}
.navBtnTxt {
  display: none;
  min-width: 150px;
}
.sideNav:hover .navBtnTxt {
  display: block;
}
</style>
